import React from "react";
import Traec from "traec";
import { ErrorBoundary } from "storybook-dashboard/errors";
import { BSCard, BSBtn } from "traec-react/utils/bootstrap";
import useToken from "storybook-dashboard/auth/token";

const clearDashboardCache = (props) => {
  let { companyId } = props;
  let fetch = new Traec.Fetch("company_dispatch", "post", { companyId });
  fetch.updateFetchParams({
    body: {
      type: "SUSTOOL_DASHBOARD_DATA",
      payload: {
        part: "CLEAR_CACHE",
      },
    },
  });
  console.log("Dispatching Company clearDashboardCache");
  fetch.dispatch();
};

function RenderID({ title, id }) {
  return (
    <tr>
      <td>
        <b>{title}</b>
      </td>
      <td>{id}</td>
    </tr>
  );
}

export function TechnicalDetails(props) {
  const { companyId } = props;
  const { getClaims } = useToken();
  const claims = getClaims();
  const isSuperUser = claims?.get("is_superuser") || claims?.get("is_tenant_superuser") || false;

  if (!isSuperUser) return null;

  return (
    <ErrorBoundary>
      <BSCard
        widthOffset="col-sm-12"
        title="Technical details"
        body={
          <table width="100%">
            <tbody>
              <RenderID title="Full Company ID" id={companyId} />
            </tbody>
          </table>
        }
      />
    </ErrorBoundary>
  );
}
